import Toolkit from '../utils/utils';
let showSec = Toolkit.commonFunction.showSec;

function header() {
    /*=================== Sticky Header  ===================*/
    if ($(".stickMain").hasClass('stick')) {
        var header_top = $(".stickMain.stick").offset().top;
    }
    $(window).scroll(() => {
        const scroll = $(window).scrollTop();
        if (scroll > header_top) {
            $(".stickMain.stick").addClass("sticky");
        } else {
            $(".stickMain.stick").removeClass("sticky");
        }
    });
    /*=================== Responsive Button Menu And Links Slide In ===================*/
    $(".responsive-bar span").on("click", e => {
        console.log(e);
        const target = $(e.target);
        const data_menu = $(e.target.attributes['data-target']).val();
        if (target.is('.open-menu') || data_menu == 'menu') {
            $(".responsive-links.other").removeClass("slideInRight");
            $(".responsive-links.menu").toggleClass("slideInLeft");
        }
        if (target.is('.open-links') || data_menu == 'links') {
            $(".responsive-links.menu").removeClass("slideInLeft");
            $(".responsive-links.other").toggleClass("slideInRight");
        }
    });


    $("html").on("click", () => {
        $(".responsive-links.other").removeClass("slideInRight");
        $(".responsive-links.menu").removeClass("slideInLeft");
    });

    $(".responsive-header").on("click", e => {
        e.stopPropagation();
    });

    /*=================== 导航交互 ===================*/
    $("nav#navigation ul.first-level > li").each(function() {
        $(this).hover(
            function() {
                // 显示二级导航
                showSec($(this), "second-wrapper", "flex");
            },
            function() {
                $(this).find(".second-wrapper").velocity({ opacity: 0 }, { display: "none" });
            }
        );
    });
    /*=================== 手机导航交互 ===================*/
    $("nav#mobileNav ul.first-level > li > a").each(function() {
        $(this).click(e => {
            const $secondLevel = $(this).next(".second-level");

            if ($secondLevel.css("display") === "none") {
                $secondLevel.velocity({ opacity: 1 }, { duration: 200, display: "block" });
            } else {
                $secondLevel.hide();
            }

        });
    });
    /*=================== 搜索交互 ===================*/
    const $nav = $("nav#navigation");
    const $searchBox = $(".stick .searchBox");

    const navW = $nav.width(),
        navH = $nav.height();

    $(".stick .ss").click(() => {
        $searchBox.css("display") === "none" ? fadeIn() : fadeOut();

        $searchBox.width(navW);
        $searchBox.height(navH);
    });

    function fadeIn() {
        $nav.hide();
        $searchBox.velocity({ opacity: 1 }, { display: "flex" });
    }

    function fadeOut() {
        $searchBox.velocity({ opacity: 0 }, {
            display: "none",
            complete() {
                $nav.show();
            }
        });
    }
    /*=================== 选择框 ===================*/
    $("#select").click(() => {
        let $opts = $(".select-opts");

        $(".select").toggleClass('on');
        if ($opts.css("visibility") === "hidden") {
            $opts.velocity({ opacity: 1 }, { visibility: "visible" });
        } else {
            $opts.velocity({ opacity: 0 }, { visibility: "hidden" });
        }

    });
}

module.exports = header;


// WEBPACK FOOTER //
// ./js/page/header.js